export default "__VITE_ASSET__3c1091b1__"